<div class="app-content content">
    <div class="content-wrapper">


      <section class="content-header">
            <h1>
              Leitstellen
            </h1>
            <button class="col-sm-1 btn btn-block " style="background-color: rgb(60, 146, 169); border-color: rgb(60, 146, 169); color: white;" (click)="openModal(null)">Erstellen</button>

        </section>
        <section class="content-body">
          <div class="form-group">
            <div class="content-wrapper">
              <div class="content-body">
                <!-- Basic Tables start -->
                <div class="row">
                  <div class="col-sm-12" *blockUI="'basicTables'; message: 'Loading'">
                    <div class="card">
                      <div class="table-responsive card-body">
                        <form>
          
                          <div class="form-group form-inline" style="display: block;">
                            
                            <label style="float: right;">Suche:
                            <input class="form-control ml-2" type="text" name="searchTerm"
                              [(ngModel)]="service.searchTerm" placeholder="Suchen..."/></label>
                            <span class="ml-3" *ngIf="service.loading$ | async">Daten werden geladen...</span>
                          </div>
          
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"></th>
                                <th scope="col" (click)="sort('leitstelle')" class="clickable-th">Leitstelle</th>
                                <th scope="col" (click)="sort('kennwort')" class="clickable-th">Kennwort</th>
                                <th scope="col" (click)="sort('telefon')" class="clickable-th">Telefon</th>
                                <th scope="col">Aktionen</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let element of leitstellen; index as i">
                                <th scope="row">{{ getFortlaufendeNummer(i) }}</th>
                                <td>
                                  <ngb-highlight [result]="element.leitstelle" [term]="service.searchTerm"></ngb-highlight>
                                </td>
                                <td>
                                    <ngb-highlight [result]="element.kennwort" [term]="service.searchTerm"></ngb-highlight>
                                  </td>
                                  <td>
                                    <ngb-highlight [result]="element.telefon" [term]="service.searchTerm"></ngb-highlight>
                                  </td>
                                    <td>
                                  <div class="btn-group" role="group">
                                    <button type="button" class="btn btn-float bg-primary" style="margin-right: 1rem; color: white;" (click)="openModalKontakt(element)"><i class="la la-info"></i>Kontakt Info</button>
                                  <button type="button" class="btn btn-float bg-blue" style="margin-right: 1rem; color: white;" (click)="openModal(element)"><i class="la la-edit"></i>Bearbeiten</button>
                                  <button type="button" class="btn btn-float bg-red" style="color: white;" (click)="deleteModal(element)"><i class="la la-trash-o"></i>Löschen</button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
          
                          <div class="d-flex justify-content-between p-2">
                            {{ rangeStart }} bis {{ rangeEnd | async }} von
                            {{ total$ | async }} Einträgen
                            
                            <ngb-pagination [collectionSize]="total$ | async" [(page)]="service.page"
                              [pageSize]="service.pageSize">
                            </ngb-pagination>
          
          
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
          
          <!------Basic table end--->               
          </div>
    </section>
    </div>

  </div>
